import { tr as __tr, useLocale as __useLocale } from "../i18n/runtime";
import React from "react";
import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import BookingTabs from "../components/BookingTabs";
import PopularDestinations from "../components/PopularDestinations";
import VisaDestinations from "../components/VisaDestinations";
import WhyChooseUs from "../components/WhyChooseUs";
import Footer from "../components/Footer";
import { CatalogProvider } from "../context/CatalogContext";
import SiteContent from '../components/SiteContent';
const Home = () => {
  __useLocale();
  return <CatalogProvider><div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <BookingTabs />
      <PopularDestinations />
      <VisaDestinations />
      <WhyChooseUs />
      <SiteContent />
      <Footer />
    </div></CatalogProvider>;
};
export default Home;
